import { React, useEffect, useRef, useState } from "react";
import { DatePicker, TimePicker } from "@material-ui/pickers";
import Button from "@material-ui/core/Button";
import axios from "axios";
import PublishIcon from "@material-ui/icons/Publish";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Select, MenuItem, InputLabel, FormControl } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { areaOfWork } from "../Constant.js";
import { DivStyled } from "../Container.styled.js";

const QuestionModal = ({ id, setIsQuestionModal }) => {
  const [questionPaper, setQuestionPaper] = useState({});
  const [autocompleteData, setAutocompleteData] = useState("");
  const [render, setRender] = useState(false);
  const [allDepartment, setAllDepartment] = useState([]);

  const handleInput = (e) => {
    questionPaper[e.target.name] = e.target.value;
  };

  useEffect(() => {
    axios
      .get(`/api/getAllDepartments`)
      .then((res) => {
        const data = res.data.result.map((item) => {
          return {
            department_id: item._id,
            department_name: item.department_name,
          };
        });
        setAllDepartment(data);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/getOneQuestionPaper/${id}`, questionPaper)
        .then((res) => {
          setQuestionPaper(res.data);
          setAutocompleteData({
            department_id: res.data?.area_of_work?._id,
            area_of_work: res.data?.area_of_work?.department_name,
          });
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  const handelSumbit = (e) => {
    if (id) {
      axios
        .patch(`/api/patchQuestionPaper/${id}`, questionPaper)
        .then((res) => {
          window.alert("success");
          setIsQuestionModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      questionPaper["levels"] = new Array(4).fill().map((_, index) => {
        return { levels_type: `Level_${index + 1}`, question: [] };
      });

      axios
        .post(`/api/createQuestionPaper`, questionPaper)
        .then((res) => {
          window.alert("success");
          setIsQuestionModal(false);
        })
        .catch((err) => {
          if (err.response.data.error.message.includes("E11000")) {
            window.alert("Can not create duplicate area of work");
          }
          console.log(err);
        });
    }
  };

  return (
    <section style={{ padding: "0.3rem 0rem 0.3rem 0rem" }}>
      <div
        className="btn_save"
        style={{
          position: "absolute",
          right: "150px",
          top: "9px",
        }}
      >
        <Button
          type="submit"
          variant="outlined"
          color="white"
          size="large"
          style={{ color: "#e9e9e9" }}
          startIcon={<PublishIcon />}
          onClick={handelSumbit}
        >
          {id ? "UPDATE" : "SUBMIT"}
        </Button>
      </div>
      <DivStyled>
        <label for="quesion_paper_name">Question Paper Name</label>
        <input
          type="text"
          id="quesion_paper_name"
          name="quesion_paper_name"
          defaultValue={questionPaper?.quesion_paper_name}
          onBlur={handleInput}
        />
      </DivStyled>
      <DivStyled>
        <label for="area_of_work">Area Of Work</label>
        <Autocomplete
          style={{
            borderLeft: "2px solid #ced4da",
            paddingLeft: "0.5rem",
            width: "100%",
            marginRight: "6rem",
          }}
          id="training_topics"
          options={allDepartment}
          getOptionLabel={(option) => option.department_name}
          getOptionSelected={(option, value) =>
            option.department_name === value.department_name
          }
          value={autocompleteData}
          onChange={(e, value) => {
            questionPaper.area_of_work = value.department_id;
            setAutocompleteData(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
              }}
            />
          )}
        />
      </DivStyled>
    </section>
  );
};

export default QuestionModal;
